
export const samsungLinks = [
    'showcase',
    'mobile',
    'tablet',
    'monitor',
    'watch',
    'headset',
    'all'
]